<div mat-dialog-title class="flex flex-row justify-between items-center">
  <h1>Change your password</h1>
  <button [mat-dialog-close]="false" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <div novalidate autocomplete="off" class="flex flex-col">
    <div class="box-container">
      <mepco-password-strength
        #passwordStrengthComponent
        [min]="passwordPolicies.minimumLength"
        [max]="30"
        [enableDigitRule]="passwordPolicies.requireNumbers"
        [enableLowerCaseLetterRule]="passwordPolicies.requireLowercase"
        [enableUpperCaseLetterRule]="passwordPolicies.requireUppercase"
        [enableSpecialCharRule]="passwordPolicies.requireSymbols"
        (passwordStrengthForm)="getFormValues($event)">
      </mepco-password-strength>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-row justify-end">
  <button mat-raised-button type="submit" color="primary" [disabled]="!passwordStrengthForm().valid" (click)="onSave()">
    Change Password
  </button>
</mat-dialog-actions>
